<!-- src/components/TaskItem.vue -->
<template>
  <li class="flex space-x-4 p-4 bg-white shadow rounded">
    <input type="checkbox" :checked="task.completed" @change="updateTaskStatus" class="form-checkbox h-5 w-5 text-blue-600">
    <div class="flex-1 text-left">
      <div class="font-semibold">{{ task.title }}</div>
    </div>
  </li>
</template>

<script>
import Task from '@/models/Task';
import { watch } from 'vue';

export default {
  name: 'TaskItem',
  props: {
    task: Task
  },

  setup(props) {

    watch(() => props.task, () => {
      console.log('Task updated:', props.task.title, props.task.completed);
    });
    
    const updateTaskStatus = () => {
      props.task.toggleCompleted()
      // Your update task status logic here
    }
    return {
      updateTaskStatus
    }
  }
}
</script>

<style scoped>
/* Add your styles here */
</style>